/**
 * useCustomCssInjection — fetches per-page custom CSS and injects a
 * <style data-wb-page-css="{page_id}"> into the document head while the
 * canvas is mounted. Cleans up on unmount or page change so CSS doesn't
 * leak between pages in single-page navigation.
 */
import { useEffect } from 'react';
import axios from 'axios';
import { scopeCss } from '../shared/siteTokens';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function useCustomCssInjection({ pageId, enabled = true }) {
  useEffect(() => {
    if (!enabled || !pageId) return;
    const token = localStorage.getItem('token');
    if (!token) return;

    let styleEl = null;
    let canceled = false;

    axios
      .get(`${API}/builder/pages/${pageId}/custom-css`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((r) => {
        if (canceled) return;
        // Scoped to the website surface so vendor CSS styles the site the
        // same way in Edit + Preview and never leaks into builder chrome.
        const css = scopeCss((r.data && r.data.css) || '');
        if (!css) return;
        styleEl = document.createElement('style');
        styleEl.setAttribute('data-wb-page-css', pageId);
        styleEl.appendChild(document.createTextNode(css));
        document.head.appendChild(styleEl);
      })
      .catch(() => {});

    return () => {
      canceled = true;
      if (styleEl && styleEl.parentNode) styleEl.parentNode.removeChild(styleEl);
    };
  }, [pageId, enabled]);
}
